import { PropsWithChildren, useRef, useState, useEffect } from 'react';
import {
  SpotlightTargetProps,
  useSpotlightManager
} from './spotlight-provider';
import { Pulse } from './spotlight-pulse';

export const SpotlightTarget = ({
  name,
  children,
  pulseSize,
  speed,
  style
}: PropsWithChildren<SpotlightTargetProps>) => {
  const targetElement = useRef<HTMLDivElement | null>(null);
  const { targets, current } = useSpotlightManager();
  const [shouldPulse, setShouldPulse] = useState(false);

  useEffect(() => {
    if (targetElement) {
      targets?.set(name, targetElement);
    }
  }, [targetElement]);

  useEffect(() => {
    setShouldPulse(targetElement == current);
  }, [current]);

  return (
    <div css={style} ref={targetElement}>
      {shouldPulse ? (
        <Pulse radius={3} pulseSize={pulseSize} speed={speed}>
          {children}
        </Pulse>
      ) : (
        children
      )}
    </div>
  );
};
